// =============================================================
// App.tsx — Root router and route configuration
// Multi-tenant SaaS — Phase 2: Onboarding & SEO Project Foundation
// =============================================================

import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';

import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import DashboardPage from './pages/DashboardPage';
import BusinessesPage from './pages/BusinessesPage';
import OnboardingPage from './pages/OnboardingPage';
import BusinessDashboardPage from './pages/BusinessDashboardPage';
import WebsiteAuditPage from './pages/WebsiteAuditPage';
import GoogleIntegrationsPage from './pages/GoogleIntegrationsPage';
import SEOIntelligencePage from './pages/SEOIntelligencePage';
import KeywordsPage from './pages/KeywordsPage';
import { ReviewsPage } from './pages/ReviewsPage';
import CompetitorsPage from './pages/CompetitorsPage';
import ReportsPage from './pages/ReportsPage';
import SettingsPage from './pages/SettingsPage';
import AIAssistantPage from './pages/AIAssistantPage';
import UserManagementPage from './pages/UserManagementPage';
import AIConfigurationPage from './pages/AIConfigurationPage';

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />

          {/* Protected Routes */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <DashboardPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/businesses"
            element={
              <ProtectedRoute>
                <BusinessesPage />
              </ProtectedRoute>
            }
          />
          {/* Phase 2: Onboarding Wizard */}
          <Route
            path="/businesses/new"
            element={
              <ProtectedRoute>
                <OnboardingPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/businesses/:businessId/onboarding"
            element={
              <ProtectedRoute>
                <OnboardingPage />
              </ProtectedRoute>
            }
          />
          {/* Phase 2: Business SEO Project Dashboard */}
          <Route
            path="/businesses/:businessId/dashboard"
            element={
              <ProtectedRoute>
                <BusinessDashboardPage />
              </ProtectedRoute>
            }
          />
          {/* Phase 3: Website SEO Audit Results */}
          <Route
            path="/businesses/:businessId/seo"
            element={
              <ProtectedRoute>
                <WebsiteAuditPage />
              </ProtectedRoute>
            }
          />
          {/* Phase 4: Google Integrations (Search Console & GBP) */}
          <Route
            path="/businesses/:businessId/integrations"
            element={
              <ProtectedRoute>
                <GoogleIntegrationsPage />
              </ProtectedRoute>
            }
          />
          {/* Phase 5A: SEO Intelligence Engine */}
          <Route
            path="/businesses/:businessId/intelligence"
            element={
              <ProtectedRoute>
                <SEOIntelligencePage />
              </ProtectedRoute>
            }
          />
          {/* Phase 7+ Step 1: Keywords Module */}
          <Route
            path="/businesses/:businessId/keywords"
            element={
              <ProtectedRoute>
                <KeywordsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/keywords"
            element={
              <ProtectedRoute>
                <KeywordsPage />
              </ProtectedRoute>
            }
          />
          {/* Phase 7+ Step 2: Reviews Module */}
          <Route
            path="/businesses/:businessId/reviews"
            element={
              <ProtectedRoute>
                <ReviewsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/reviews"
            element={
              <ProtectedRoute>
                <ReviewsPage />
              </ProtectedRoute>
            }
          />
          {/* Phase 7+ Step 3: Competitors Module */}
          <Route
            path="/businesses/:businessId/competitors"
            element={
              <ProtectedRoute>
                <CompetitorsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/businesses/:businessId/competitors/:competitorId"
            element={
              <ProtectedRoute>
                <CompetitorsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/competitors"
            element={
              <ProtectedRoute>
                <CompetitorsPage />
              </ProtectedRoute>
            }
          />
          {/* Phase 7+ Step 4: Reports Module */}
          <Route
            path="/businesses/:businessId/reports"
            element={
              <ProtectedRoute>
                <ReportsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/businesses/:businessId/reports/:reportType"
            element={
              <ProtectedRoute>
                <ReportsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/reports"
            element={
              <ProtectedRoute>
                <ReportsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/businesses/:businessId/ai-assistant"
            element={<ProtectedRoute><AIAssistantPage /></ProtectedRoute>}
          />
          <Route
            path="/settings"
            element={
              <ProtectedRoute>
                <SettingsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/users"
            element={
              <ProtectedRoute>
                <UserManagementPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/ai-config"
            element={
              <ProtectedRoute>
                <AIConfigurationPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ai-config"
            element={
              <ProtectedRoute>
                <AIConfigurationPage />
              </ProtectedRoute>
            }
          />

          {/* Default fallbacks */}
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
